import { EventAvailableOutlined } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

export const RecoloredEventAvailableOutlined = styled(EventAvailableOutlined)(({ theme }) => ({
  color: `${theme.palette.action.active} !important`,
}));
